import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { toast } from 'react-toastify';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import TapSelect from '../../../components/ui/TapSelect';
import DatePicker from "react-datepicker";
import moment from 'moment';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';

const AddDeviceDataListing = ({ history, location }) => {
    const access_token = useSelector(state => state.auth.access_token);
    const [submitLoading, setSubmitLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    const [manufacturerData, setManufacturerData] = useState([])
    const [deviceTypeData, setDeviceTypeData] = useState([])
    const [allModels, setAllModels] = useState([])
    const [filteredModels, setFilteredModels] = useState([])
    const [formData, setFormData] = useState({
        id: "",
        device_id: "",
        manufacturer_id: "",
        modal_id: "",
        imei_no: "",
        device_type_id: "",
        product_serial_no: "",
        manufacturer_device_id: "",
        date_of_purchase: "",
        invoice_no: "",
        notes: "",
        terminal_id: "",
        hour_applicable: "N",
        odo_meter_applicable: "N",
        movable: "N",
        ignition: "N",
        accelerometer: "N",
        linked_id: "",
        device_type: "",
        modal: ""
    })
    const [isEditMode, setIsEditMode] = useState(false)

    const getFormData = () => {
        setLoading(true)
        HttpAPICall.withAthorization('GET', BACKOFFICE_BASE_URL + '/device_form_data', access_token, {}, {}, (resp) => {
            const respData = resp.data
            setManufacturerData(respData?.manufacturers && respData.manufacturers.map(mf => ({ label: mf.name, value: mf.id })))
            setDeviceTypeData(respData?.device_types && respData.device_types.map(mf => ({ label: mf.name, value: mf.id })))
            if (respData?.models) {
                setAllModels(respData.models.map(model => ({
                    label: model.name,
                    value: model.id,
                    manufacturer_id: model.manufacturer_id
                })))
            }
        }).then(() => setLoading(false));
    }

    useEffect(() => {
        if (formData.manufacturer_id) {
            const filtered = allModels.filter(model =>
                model.manufacturer_id === Number(formData.manufacturer_id)
            );
            setFilteredModels(filtered);

            const currentModel = allModels.find(m => m.value === formData.modal_id);
            if (currentModel && currentModel.manufacturer_id !== Number(formData.manufacturer_id)) {
                setFormData(prev => ({ ...prev, modal_id: "" }));
            }
        } else {
            setFilteredModels([]);
            if (formData.modal_id) {
                setFormData(prev => ({ ...prev, modal_id: "" }));
            }
        }
    }, [formData.manufacturer_id, allModels]);

    const backToListing = () => {
        history.push({ pathname: '/device' });
    }

    useEffect(() => {
        initialFormData()
    }, []);


    const tapSelectChange = (selectedOption, formKey) => {
        setFormData(prev => ({
            ...prev,
            [formKey]: selectedOption ? Number(selectedOption.value) : ""
        }));
    };

    const initialFormData = () => {
        getFormData();

        const editData = location?.state?.editdeviceDataListing;

        if (editData) {
            console.log(editData);
            
            setFormData({
                id: editData.id || "",
                device_id: editData.device_id || "",
                manufacturer_id: editData?.manufacturer?.id  || "",
                modal_id: editData?.modal?.id || "",
                imei_no: editData.imei_no || "",
                device_type_id: editData?.device_type?.id || "",
                product_serial_no: editData.product_serial_no || "",
                manufacturer_device_id: editData.manufacturer_device_id || "",
                terminal_id: editData.terminal_id || "",
                date_of_purchase: editData.date_of_purchase
                    ? new Date(editData.date_of_purchase)
                    : "",
                invoice_no: editData.invoice_no || "",
                notes: editData.notes || "",
                hour_applicable: editData?.linked_device?.hour_applicable || "N",
                odo_meter_applicable: editData?.linked_device?.odo_meter_applicable || "N",
                movable: editData?.linked_device?.movable || "N",
                ignition: editData?.linked_device?.ignition || "N",
                accelerometer: editData?.linked_device?.accelerometer || "N",
                linked_id: editData?.linked_id || editData?.linked_device?.id || "",
                device_type: editData?.device_type?.name || "",
                modal: editData?.modal?.name || ""
            });

            setIsEditMode(true);
        } else {
            setFormData({
                id: "",
                device_id: "",
                manufacturer_id: "",
                modal_id: "",
                imei_no: "",
                device_type_id: "",
                product_serial_no: "",
                manufacturer_device_id: "",
                date_of_purchase: "",
                invoice_no: "",
                notes: "",
                terminal_id: "",
                hour_applicable: "N",
                odo_meter_applicable: "N",
                movable: "N",
                ignition: "N",
                accelerometer: "N",
                linked_id: "",
                device_type: "",
                modal: ""
            });
            setIsEditMode(false);
        }
    };

    const handleDateTimeChange = (value) => {
        setFormData(prev => ({
            ...prev,
            date_of_purchase: value
        }));
    };

    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const submitDataForm = (e) => {
        e.preventDefault();

        const payload = {
            ...formData,
            date_of_purchase: formData.date_of_purchase
                ? moment(formData.date_of_purchase).format("YYYY-MM-DD")
                : ""
        };


        if (!isEditMode) {
            delete payload.id;
            delete payload.linked_id;
        }

        setSubmitLoading(true);

        if (isEditMode) {
            HttpAPICall.withAthorization('PUT', BACKOFFICE_BASE_URL + '/device_edit', access_token, {}, payload, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                history.push({ pathname: '/device', state: { id: formData.id } });

                
            }).then(() => setSubmitLoading(false));
        } else {
            HttpAPICall.withAthorization(
                'POST', BACKOFFICE_BASE_URL + '/device_add', access_token, {}, payload, (resp) => {
                    toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    backToListing();
                }
            ).then(() => setSubmitLoading(false));
        }
    };

    const formInputHandler = (e) => {
        setFormData(pre => ({ ...pre, [e.target.name]: e.target.value }));
    };



    const formDatajsx = () => {
        return (
            <>
                <form className="bg-white p-3" onSubmit={submitDataForm} id="saveResourceForm">
                    {loading ? <Loader />
                        :
                        <>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">Device Id</label>
                                </div>
                                <div className="col-sm-6 ">
                                    <input
                                        name="device_id"
                                        type="text"
                                        value={formData.device_id}
                                        className="form-control"
                                        autoComplete="off"
                                        required={true}
                                        onChange={formInputHandler}
                                        disabled={isEditMode}
                                        placeholder="Please enter Device Id"
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">Device Type</label>
                                </div>
                                <div className="col-sm-6 ">
                                    <TapSelect
                                        changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'device_type_id')}
                                        options={deviceTypeData}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={deviceTypeData.find(
                                            s => formData.device_type_id == s.value
                                        )}
                                        placeholder={"Please Select Device Type"}
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label ">Icmei</label>
                                </div>
                                <div className="col-sm-6 ">
                                    <input
                                        name="imei_no"
                                        type="text"
                                        value={formData.imei_no}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={formInputHandler}
                                        placeholder="Please enter Icmei"
                                        disabled={isEditMode}
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">Manufacturer</label>
                                </div>
                                <div className="col-sm-6 ">
                                    <TapSelect
                                        changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'manufacturer_id')}
                                        options={manufacturerData}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={manufacturerData.find(
                                            s => formData.manufacturer_id == s.value
                                        )}
                                        placeholder={"Please Select Manufacturer"}
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label">Manufacturer Device Id</label>
                                </div>
                                <div className="col-sm-6 ">
                                    <input
                                        name="manufacturer_device_id"
                                        type="text"
                                        value={formData.manufacturer_device_id}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={formInputHandler}
                                        placeholder="Please enter Manufacturer Device Id"

                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label">Terminal Id</label>
                                </div>
                                <div className="col-sm-6 ">
                                    <input
                                        name="terminal_id"
                                        type="number"
                                        value={formData.terminal_id}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={formInputHandler}
                                        placeholder="Please enter Terminal Id"
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label ">Model</label>
                                </div>
                                <div className="col-sm-6 ">
                                    <TapSelect
                                        changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'modal_id')}
                                        options={filteredModels}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={filteredModels.find(
                                            s => formData.modal_id == s.value
                                        )}
                                        placeholder={"Please Select Model"}
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label">Product Serial No</label>
                                </div>
                                <div className="col-sm-6 ">
                                    <input
                                        name="product_serial_no"
                                        type="text"
                                        value={formData.product_serial_no}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={formInputHandler}
                                        placeholder="Please enter Product Serial no."

                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label ">Invoice No</label>
                                </div>
                                <div className="col-sm-6 ">
                                    <input
                                        name="invoice_no"
                                        type="text"
                                        value={formData.invoice_no}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={formInputHandler}
                                        placeholder="Please enter Invoice No"
                                    />
                                </div>
                            </div>

                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label ">Date Of Purchase</label>
                                </div>
                                <div className="col-sm-6 ">
                                    <DatePicker
                                        selected={formData.date_of_purchase}
                                        onChange={(value) => handleDateTimeChange(value)}
                                        dateFormat="dd-MMM-yyyy"
                                        className="form-control"
                                        showMonthDropdown
                                        showYearDropdown
                                        autoComplete="off"
                                        scrollMonthYearDropdown
                                        placeholderText="Please Enter Date "
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label ">Notes</label>
                                </div>
                                <div className="col-sm-6 ">
                                    <input
                                        name="notes"
                                        type="text"
                                        value={formData.notes}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={formInputHandler}
                                        placeholder="Please enter Notes"
                                    />
                                </div>
                            </div>

                            
                            
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label className="form-label">Hour Applicable</label>
                                </div>
                                <div className="col-sm-2">
                                    <div className="d-flex gap-3">
                                        <div className="form-check">
                                            <input
                                                id="y1"
                                                className="form-check-input"
                                                type="radio"
                                                name="hour_applicable"
                                                value="Y"
                                                checked={formData.hour_applicable === "Y"}
                                                onChange={handleRadioChange}
                                            />
                                            <label className="form-check-label" htmlFor="y1">Yes</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                id="n1"
                                                className="form-check-input"
                                                type="radio"
                                                name="hour_applicable"
                                                value="N"
                                                checked={formData.hour_applicable === "N"}
                                                onChange={handleRadioChange}
                                            />
                                            <label className="form-check-label" htmlFor="n1">No</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-2">
                                    <label className="form-label">Odo Meter Applicable</label>
                                </div>
                                <div className="col-sm-2">
                                    <div className="d-flex gap-3">
                                        <div className="form-check">
                                            <input
                                                id="y2"
                                                className="form-check-input"
                                                type="radio"
                                                name="odo_meter_applicable"
                                                value="Y"
                                                checked={formData.odo_meter_applicable === "Y"}
                                                onChange={handleRadioChange}
                                            />
                                            <label className="form-check-label" htmlFor="y2">Yes</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                id="n2"
                                                className="form-check-input"
                                                type="radio"
                                                name="odo_meter_applicable"
                                                value="N"
                                                checked={formData.odo_meter_applicable === "N"}
                                                onChange={handleRadioChange}
                                            />
                                            <label className="form-check-label" htmlFor="n2">No</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label className="form-label">Movable</label>
                                </div>
                                <div className="col-sm-2">
                                    <div className="d-flex gap-3">
                                        <div className="form-check">
                                            <input
                                                id="y3"
                                                className="form-check-input"
                                                type="radio"
                                                name="movable"
                                                value="Y"
                                                checked={formData.movable === "Y"}
                                                onChange={handleRadioChange}
                                            />
                                            <label className="form-check-label" htmlFor="y3">Yes</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                id="n3"
                                                className="form-check-input"
                                                type="radio"
                                                name="movable"
                                                value="N"
                                                checked={formData.movable === "N"}
                                                onChange={handleRadioChange}
                                            />
                                            <label className="form-check-label" htmlFor="n3">No</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-2">
                                    <label className="form-label">Ignition</label>
                                </div>
                                <div className="col-sm-2">
                                    <div className="d-flex gap-3">
                                        <div className="form-check">
                                            <input
                                                id="y4"
                                                className="form-check-input"
                                                type="radio"
                                                name="ignition"
                                                value="Y"
                                                checked={formData.ignition === "Y"}
                                                onChange={handleRadioChange}
                                            />
                                            <label className="form-check-label" htmlFor="y4">Yes</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                id="n4"
                                                className="form-check-input"
                                                type="radio"
                                                name="ignition"
                                                value="N"
                                                checked={formData.ignition === "N"}
                                                onChange={handleRadioChange}
                                            />
                                            <label className="form-check-label" htmlFor="n4">No</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label className="form-label">Accelerometer</label>
                                </div>
                                <div className="col-sm-2">
                                    <div className="d-flex gap-3">
                                        <div className="form-check">
                                            <input
                                                id="y5"
                                                className="form-check-input"
                                                type="radio"
                                                name="accelerometer"
                                                value="Y"
                                                checked={formData.accelerometer === "Y"}
                                                onChange={handleRadioChange}
                                            />
                                            <label className="form-check-label" htmlFor="y5">Yes</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                id="n5"
                                                className="form-check-input"
                                                type="radio"
                                                name="accelerometer"
                                                value="N"
                                                checked={formData.accelerometer === "N"}
                                                onChange={handleRadioChange}
                                            />
                                            <label className="form-check-label" htmlFor="n5">No</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    <div className="col-12 text-end fixed_footer">
                        <button type="button" className="btn btn-secondary mx-3" onClick={backToListing} disabled={submitLoading}>Cancel</button>
                        <button type="submit" className="btn btn-primary mx-2" disabled={submitLoading}>
                            Save {submitLoading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                        </button>
                    </div>
                </form>
            </>
        );
    };

    const addManufacturerJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    <div className="col-12">
                        <h3> {isEditMode ? "Edit " : "Add "} Device</h3>
                        <div className="text-end mt15">
                            <button type="button" className="btn btn-secondary" onClick={backToListing}>
                                <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-action" />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', 'col-12'].join(' ')}>{formDatajsx()}</div>
                    </div>
                </div>
            </>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Add Device</title></Helmet>
            {addManufacturerJsx()}
        </ApplicationLayout>
    );
};

export default AddDeviceDataListing;